import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { IconOption, IconService } from '@app/shared/services/icon.service';
import { FormControl } from '@angular/forms';
import { ComponentsModule } from '@app/shared/components/components.module';
import { CommonModule, NgIf } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';

@Component({
  selector: 'app-icon-dropdown',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './icon-dropdown.component.html',
  imports: [ComponentsModule, CommonModule, MatSelectModule, MatOptionModule, NgIf, SharedModule],
})
export class IconDropdownComponent implements OnInit {
  @Input() label: string = 'Select an Icon';
  @Input() value: string;
  @Input() placeholder: string = 'Choose an icon...';
  @Output() selectionChange = new EventEmitter<IconOption>();

  iconControl = new FormControl<IconOption | null>(null);
  icons: IconOption[] = [];
  loading: boolean = true;
  error: string | null = null;

  constructor(private iconService: IconService) {}

  /**
   * Load icons when component is initialized
   * This ensures icons are loaded whenever the page containing this component is navigated to
   */
  ngOnInit(): void {
    this.loadIcons();

    // Subscribe to value changes in the form control
    this.iconControl.valueChanges.subscribe(selectedIcon => {
      if (selectedIcon) {
        this.selectionChange.emit(selectedIcon);
      }
    });
  }

  /**
   * Fetches icons from the SCSS file and processes them
   * This is called only once when the component is initialized
   */
  loadIcons(): void {
    this.loading = true;
    this.iconService.getIconOptions()
      .subscribe({
        next: (icons) => {
          this.icons = icons.sort((a, b) => a.name.localeCompare(b.name));
          if (this.value) {
            const selectedIcon = this.icons.find(icon => icon.className === this.value);
            this.iconControl.patchValue(selectedIcon);
          }
          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to load icons:', err);
          this.error = 'Failed to load icons. Please check the SCSS file.';
          this.loading = false;
        }
      });
  }
}
